export default __webpack_public_path__ + "static/logo-3-5ed836fa38618f46f55ab4fe5011cb3d.png";